import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabChangeEvent, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ComunicacionService } from '../../../../providers/comunicacion.service';
import { DetalleService } from '../../../../providers/detalle.service';
import { CotizacionService } from '../../../../providers/cotizacion.service';
import { OrdenVentaComponent } from '../../../../forms/orden-venta/orden-venta.component';
import { ConfirmComponent } from '../../../../components/confirm/confirm.component';
import { ZerosPipe } from '../../../../pipes/transforms/zeros.pipe';
import { AsignacionStockComponent } from '../../../../forms/orden-venta/asignacion-stock/asignacion-stock.component';

@Component({
  selector: 'app-detalle-ov',
  templateUrl: './detalle-ov.component.html',
  styleUrls: ['./detalle-ov.component.scss']
})
export class DetalleOvComponent implements OnInit {
  id: number;
  element: any = {};
  cargando: boolean[] = [];
  tabSelectedIndex: number = 0;
  titulo: string = 'operación de venta';
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  constructor(
    private _route: ActivatedRoute,
    private _cotizacionSv: CotizacionService,
    private _cmSv: ComunicacionService,
    private _detalleSv: DetalleService,
    private _dialog: MatDialog,
    private _zerosPipe: ZerosPipe,
    private _router: Router,
  ) { }

  ngOnInit() {
    this._route.params.subscribe(params => {
      this.id = params['id'];
      this.actualizar();
    });
  }

  ngAfterContentChecked() {
    if (this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.length > 1) {
      this.tabSelectedIndex = this._detalleSv.getDetalleTabActivo(
        'DETALLE_' + this.titulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toUpperCase()
      );
    }
  }

  selectedTabChange(event: MatTabChangeEvent) {
    var tabActivo = +event.index;
    this._detalleSv.setDetalleTabActivo(
      'DETALLE_' + this.titulo.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "_").toUpperCase(),
      tabActivo
    );
  }

  actualizar() {
    this.cargando.push(true);
    this._cotizacionSv
      .getOrdenesVenta(
        {
          page: null,
          pageSize: null,
        },
        {
          sort: null,
          order: null,
        },
        {
          id: this.id
        }
      )
      .subscribe(
        respuesta => {
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.element = data.ordenes[0];
          }
        },
        () => {
          this.cargando.pop();
        },
        () => {
          this.cargando.pop();
        }
      );
  }

  editar = (model) => {
    this._dialog.open(OrdenVentaComponent, {
      disableClose: true,
      minWidth: '840px',
      data: {
        titulo: 'OPERACIÓN DE VENTA',
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizar();
    });
  }

  cambiarEstado = (estado: number) => {
    const estadoDescripcion = estado == 2 ? '<span class="green">ACEPTAR</span>' : '<span class="red">RECHAZAR</span>';
    this._dialog.open(ConfirmComponent, {
      minWidth: '360px',
      data: {
        texto: 'Confirme si desea <b>' + estadoDescripcion + '</b> la operación <b>' + this._zerosPipe.transform(this.element.id, 7) + '</b>',
        botones: [
          {
            label: 'CONFIRMAR',
            color: 'accent',
            action: () => {
              this.cargando.push(true);
              this._dialog.closeAll();
              this._cotizacionSv.cambiarEstado({ ...this.element, ...{ orden_venta_estado_id: estado } }).subscribe(
                (respuesta) => {
                  this.cargando.pop();
                  const data = this._cmSv.format(respuesta, true);
                  if (data != this._cmSv.SIN_DATA) {
                  }
                },
                () => {
                  this.cargando.pop();
                  this._dialog.closeAll();
                }
              );
            }
          },
          {
            label: 'CANCELAR',
            action: () => {
              this._dialog.closeAll();
            }
          }
        ]
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizar();
    });
  }

  asignacion = (model) => {
    this._dialog.open(AsignacionStockComponent, {
      disableClose: true,
      minWidth: '980px',
      data: {
        model: model
      }
    }).afterClosed().subscribe((respuesta) => {
      this.actualizar();
    });
  }

  detalleOrdenTrabajo = (ot_detalle) => {
    this.cargando.push(true);
    this._router.navigate(['logueado/detalle-ot/', ot_detalle.orden_trabajo_id]);
  }

  getNumerosDeMaquina = (numeros) => numeros.map(x => x.id).join(' - ');
}
